import { DriverLicence } from '@borg/types';

class DriverLicencesRepository extends Repository<DriverLicence> {
  getMany() {
    return this._getMany({ url: `/apps/driver-licences` });
  }
}

export const driverLicencesRepository = new DriverLicencesRepository();
